import { render, staticRenderFns } from "./DigitalSignatureSendModal.vue?vue&type=template&id=2bf04946&"
import script from "./DigitalSignatureSendModal.vue?vue&type=script&lang=js&"
export * from "./DigitalSignatureSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports